/**
 * Contract addresses whose transactions must not appear in the explorer UI.
 */
export const EXCLUDED_CONTRACT_ADDRESSES = [
  '0x4cF1eD63cA19EB4ca00Ec447eAf2388d52A2A141', // I-LIFE-TOKEN
  '0x9cc95094B38a8e1f958dcF2663574A602b3961b3', // DINAAR
  '0x3F715abf0563f18cC07bc5d24838d2e2B9C91912', // DINAAR
  '0x6bef89C35d332a71fa38d05a65264a0D7666EeD2', // Dinaar-Tk
  '0xA2B2399afAD78E47f5F5AB0b5ee26d7068Adc3FB', // Dinaar-Tk
  '0xEeC3a5016A79C6af3b32122FF84bc73b4278300a', // Dinaar-Tk
  '0x4ef46731dEbd411bc2B2475B25a855567b34670c', // SAYA (SNFT)
] as const;
